//LL: 10.07.23 Calendar (copy Grid)

import * as _ from 'underscore'; //LL: 16.07.23: after OE's great changes in GIT

import { ColorBoxField } from '../../../../_common/platform/ts/ColorBoxField';
import SelectField from '../../../../_common/platform/ts/SelectField';
import BooleanField from '../../../../_common/platform/ts/BooleanField';
import NumberField from '../../../../_common/platform/ts/NumberField';
import StringField from '../../../../_common/platform/ts/StringField';

import { CalendarMarkersField } from '../components/CalendarMarkersFieldClass'; //LL: 07.08.23  Calendar

import { AttributesParameterField, IAttributesFieldOptions } from '../components/AttributesField'; //LL: 11.09.23  Calendar

import * as validators from '../components/Validators';
import { validators as ValidatorPlatform } from '../../../../_common/platform/ts/validators';
import * as Config from '../config'; //LL: 02.08.23F

// Theme dispatcher module
import * as appTheme from '../../../../_common/platform/ts/appTheme';

// Any dependency themes, which should be initialized before this one
import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';

//LL: 10.07.23 Calendar: rem
import { ThemePreview } from './ThemePreview';

//LL: 10.07.23 Calendar:  rem   NO
// CSS template for the widget
const template = require('!!raw-loader!pdc-widget-calendar/src/mainTheme.template.css').default;

//LL: 10.07.23 Calendar: rem   NO
// A hack, to make sure that TS compiler will include this module as dependency in generated AMD
template;

declare var Color: any;

// This array, which saves all glob objects, on which theme was initialized
// It's used to make sure that `init` is launched only once for each glob.
// Here, it's possible that platform will run init for widgetTheme more than 1 time.
var _init = [];

export function init(glob) {
    // If init already invoked – halt
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    // Init parent theme
    widgetTheme(glob);

    //LL: 28.06.24
    const sectionMainId = Config.themeId; // 'widget-calendar'
    //LL: 26.06.24
    const sectionPeriodVisualizationId = Config.themeId + '-PeriodVisualization'; // 'widget-calendar-PeriodVisualization'
    //LL: 27.06.24
    const groupPeriodVisualization_emptyDays_Id = 'calendar-visualization-emptyDays';
    const groupPeriodVisualization_legend_Id = 'calendar-visualization-legend';

    //LL: 21.10.24:
    const groupFilterVariables_Id = 'calendar-FilterVariables';
    const groupFilterVariables_FromDate_Id = 'calendar-FilterVariables-FromDate';
    const groupFilterVariables_ToDate_Id = 'calendar-FilterVariables-ToDate';
    const groupFilterVariables_Months_Id = 'calendar-FilterVariables-Months';
    const groupFilterVariables_ForbidPeriodFilter_Id = 'calendar-FilterVariables-ForbidPeriodFilter';

    // Register section, which will be displayed on the left of theme edit component
    appTheme.registerSections([
        {
            id: sectionMainId,
            name: 'Calendar',
            parent: 'widget',
            //preview: ThemePreview, //LL: 10.07.23 Calendar: rem
            //previewClassName: 'preview-widget preview-widget-calendar',  //LL: 10.07.23 Calendar: rem

            themeType: 'Widget Calendar',
            visibility: ['application', 'workspace', 'pdc-widget-calendar']
        },

        //LL: 01.08.23: new Calendar
        {
            id: sectionPeriodVisualizationId,
            name: 'Period Visualization',
            parent: sectionMainId,
            themeType: 'Widget Calendar',
            visibility: ['application', 'workspace', 'pdc-widget-calendar']
        }
    ]);

    // gray-base    = main fore coloe
    // surface-bg   = main background

    appTheme.registerGroups([
        //LL: 28.07.23: new Calendar
        {
            id: 'calendar-layout',
            name: 'Layout',
            section: sectionMainId
        },

        //LL: 21.10.24: new Calendar
        {
            id: groupFilterVariables_Id,
            name: 'Define Calendar Period', // 'Filter Variables',
            section: sectionMainId
        },

        //LL: let
        {
            id: 'calendar-panel-header',
            name: 'Column Headers',
            section: sectionMainId
        },

        //LL: 01.08.23: new Calendar
        {
            id: 'calendar-YearMonth-column',
            name: 'Year/Month Column(s)',
            section: sectionMainId
        },

        //LL: let
        {
            id: 'calendar-panel-rows',
            name: 'Rows',
            section: sectionMainId
        },

        //LL: let
        {
            id: 'calendar-lines-options',
            name: 'Grid Lines',
            section: sectionMainId
        },

        //LL: only 1 option
        {
            id: 'calendar-group-options',
            name: 'Others',
            section: sectionMainId
        },

        //LL: 01.08.23 Calendar:  rem:   Leo does not want
        //LL: let.
        //{
        //    id: 'calendar-group-search',
        //    name: 'Search Panel',
        //    section: sectionMainId
        //},

        //LL: 10.07.23 Calendar:  rem:
        //{
        //    id: 'grid-group-column-chooser',
        //    name: 'Column Chooser Options',
        //    section: sectionMainId
        //},

        //LL: 10.07.23 Calendar:  rem:  ???
        //{
        //    id: 'grid-group-native-scrollbar',
        //    name: 'Scrollbar',
        //    section: sectionMainId
        //}

        //LL: 01.08.23: new Calendar
        {
            id: groupPeriodVisualization_emptyDays_Id,
            name: 'Holidays, Weekends, Empty Days',
            section: sectionPeriodVisualizationId
        },
        //LL: 27.06.24
        {
            id: groupPeriodVisualization_legend_Id,
            name: 'Legend',
            section: sectionPeriodVisualizationId
        },
        //LL: 11.09.23:
        {
            id: 'calendar-visualization-markers-dataQuery',
            name: 'Period Types',
            section: sectionPeriodVisualizationId
        },
        {
            id: 'calendar-visualization-markers',
            name: 'Period Styles', //'Customize Markers',
            section: sectionPeriodVisualizationId
        },
        //LL: sample:
        // almindelig sygdom - распространенное заболевание
        {
            id: 'calendar-visualization-almindelig-sygdom',
            name: 'almindelig sygdom',
            section: sectionPeriodVisualizationId
        }
    ]);

    // Register theme variables
    appTheme.registerVars([
        //LL: 28.07.23: new Calendar

        // Debug (temp) ============================================
        {
            id: 'widget-calendar-debug-mode',
            hidden: true, //LL: 29.08.23
            param: new BooleanField(glob, 'Debug Mode', [], false),
            section: sectionMainId
        },

        // Layout ============================================
        {
            id: 'widget-calendar-show-person',
            hidden: true, //LL: 29.08.23
            param: new BooleanField(glob, 'Display Selected Person', [], false),
            section: sectionMainId,
            group: 'calendar-layout'
        },

        //LL: 21.10.24:
        // FilterVariables ============================================
        //const groupFilterVariables_Id = 'calendar-FilterVariables';
        {
            id: groupFilterVariables_ForbidPeriodFilter_Id,
            param: new BooleanField(glob, 'Forbid Period Filter', [], true),
            section: sectionMainId,
            group: groupFilterVariables_Id
        },
        {
            id: groupFilterVariables_FromDate_Id,
            param: new StringField(
                glob,
                'Filter Variable for "From" Date',
                [/*ValidatorPlatform.string.notAllBlanks*/],
                'CalendarDayFrom',
                { allowNull: true }
            ),
            section: sectionMainId,
            group: groupFilterVariables_Id
        },
        {
            id: groupFilterVariables_ToDate_Id,
            param: new StringField(
                glob,
                'Filter Variable for "To" Date',
                [/*ValidatorPlatform.string.notAllBlanks*/],
                'CalendarDayTo',
                { allowNull: true }
            ),
            section: sectionMainId,
            group: groupFilterVariables_Id
        },
        {
            id: groupFilterVariables_Months_Id,
            param: new StringField(
                glob,
                'Filter Variable for Number of Months',
                [/*ValidatorPlatform.string.notAllBlanks*/],
                'CalendarMonths',
                { allowNull: true }
            ),
            section: sectionMainId,
            group: groupFilterVariables_Id
        },

        // Header ============================================
        {
            id: 'widget-calendar-hd-color',
            param: new ColorBoxField(
                glob,
                'Header Font Color',
                [],
                function (theme) {
                    return theme['on-secondary'];
                },
                { hideTransparency: true }
            ),
            section: sectionMainId,
            deps: ['on-secondary'],
            group: 'calendar-panel-header'
        },
        {
            id: 'widget-calendar-hdbg-color',
            param: new ColorBoxField(
                glob,
                'Header Background Color',
                [],
                function (theme) {
                    return theme['secondary-bg'];
                },
                { hideTransparency: false }
            ),
            section: sectionMainId,
            deps: ['secondary-bg'],
            group: 'calendar-panel-header'
        },
        {
            id: 'widget-calendar-header-alignment',
            param: new SelectField(glob, 'Column Header Alignment', [], 'default', {
                values: ['default', 'left', 'center', 'right'],
                display: ['default', 'left', 'center', 'right']
            }),
            section: sectionMainId,
            group: 'calendar-panel-header'
        },

        //LL: 01.08.23: new Calendar
        // YearMonth column: ============================================
        {
            id: 'widget-calendar-month-singleColumn',
            param: new BooleanField(glob, 'Use single column to display combined Year + Month', [], true),
            section: sectionMainId,
            group: 'calendar-YearMonth-column'
        },
        {
            id: 'widget-calendar-month-colbg-color',
            param: new ColorBoxField(
                glob,
                'Year/Month Column(s) Background Color',
                [],
                '#f0f4c3', //'#cceecc',
                //function (theme) {
                //    return theme['surface-bg'];
                //},
                { hideTransparency: false }
            ),
            section: sectionMainId,
            //deps: ['surface-bg'],
            group: 'calendar-YearMonth-column'
        },
        {
            id: 'widget-calendar-month-col-color',
            param: new ColorBoxField(
                glob,
                'Year/Month Column(s) Font Color',
                [],
                '#000000',
                //function (theme) {
                //    return theme['gray-base'];
                //},
                { hideTransparency: true }
            ),
            section: sectionMainId,
            //deps: ['gray-base'],
            group: 'calendar-YearMonth-column'
        },

        {
            id: 'widget-calendar-month-header-color',
            param: new ColorBoxField(
                glob,
                'Year/Month Column(s) Header Color',
                [],
                //'#a5b027',
                function (theme) {
                    return theme['widget-calendar-hdbg-color'];
                },
                { hideTransparency: true }
            ),
            section: sectionMainId,
            deps: ['widget-calendar-hdbg-color'],
            group: 'calendar-YearMonth-column'
        },
        {
            id: 'widget-calendar-month-header-caption',
            param: new StringField(
                glob,
                'Month Column Caption',
                [ValidatorPlatform.string.notAllBlanks],
                'Måned', //'Month', //  ‘År    Måned’
                { allowNull: false }
            ),
            section: sectionMainId,
            group: 'calendar-YearMonth-column'
        },
        {
            id: 'widget-calendar-year-header-caption',
            param: new StringField(
                glob,
                'Year Column Caption',
                [ValidatorPlatform.string.notAllBlanks],
                'År', //'Year', //  ‘År    Måned’
                { allowNull: false }
            ),
            section: sectionMainId,
            group: 'calendar-YearMonth-column'
        },
        {
            id: 'widget-calendar-Year/Month-Combined-header-caption',
            param: new StringField(
                glob,
                'Year/Month Combined Column Caption',
                [ValidatorPlatform.string.notAllBlanks],
                'År Måned', //'Year/Month', //  ‘År    Måned’
                { allowNull: false }
            ),
            section: sectionMainId,
            group: 'calendar-YearMonth-column'
        },

        // ROWS panel: ==================================================
        {
            id: 'widget-calendar-row-color',
            param: new ColorBoxField(
                glob,
                'Row Font Color',
                [],
                function (theme) {
                    return theme['gray-base'];
                },
                { hideTransparency: true }
            ),
            section: sectionMainId,
            deps: ['gray-base'],
            group: 'calendar-panel-rows'
        },
        {
            id: 'widget-calendar-rowbg-color',
            param: new ColorBoxField(
                glob,
                'Row Background Color',
                [],
                function (theme) {
                    return theme['surface-bg'];
                },
                { hideTransparency: false }
            ),
            section: sectionMainId,
            deps: ['surface-bg'],
            group: 'calendar-panel-rows'
        },
        //LL: ?? not needed ?
        {
            id: Config.themeFields.rowHighligtingColor,
            param: new ColorBoxField(glob, 'Row Highligting Color', [], '#0D47A1', { hideTransparency: true }),
            section: sectionMainId,
            deps: ['gray-base'],
            group: 'calendar-panel-rows'
        },
        //LL: do not use
        //{
        //    id: 'widget-calendar-row-alternation',
        //    param: new BooleanField(glob, 'Row Alternation', [], true),
        //    section: sectionMainId,
        //    group: 'calendar-panel-rows'
        //},
        {
            id: 'widget-calendar-hover-enabled',
            param: new BooleanField(glob, 'Row Hover', [], true),
            section: sectionMainId,
            group: 'calendar-panel-rows'
        },
        {
            id: 'widget-calendar-padding-top',
            param: new StringField(
                glob,
                'Row Padding top (auto|length specified in px, pt, cm, etc | %)',
                [validators.length.pixel_percent],
                '2px'
            ),
            section: sectionMainId,
            group: 'calendar-panel-rows'
        },
        {
            id: 'widget-calendar-padding-bottom',
            param: new StringField(
                glob,
                'Row Padding bottom (auto|length specified in px, pt, cm, etc | %)',
                [validators.length.pixel_percent],
                '2px'
            ),
            section: sectionMainId,
            group: 'calendar-panel-rows'
        },
        {
            id: 'widget-calendar-padding-left',
            param: new StringField(
                glob,
                'Column Padding left (auto|length specified in px, pt, cm, etc | %)',
                [validators.length.pixel_percent],
                '2px'
            ),
            section: sectionMainId,
            group: 'calendar-panel-rows'
        },
        {
            id: 'widget-calendar-padding-right',
            param: new StringField(
                glob,
                'Column Padding right (auto|length specified in px, pt, cm, etc | %)',
                [validators.length.pixel_percent],
                '2px'
            ),
            section: sectionMainId,
            group: 'calendar-panel-rows'
        },

        // Panel "Grid Lines" ==========================================
        {
            id: 'widget-calendar-show-row-lines',
            param: new BooleanField(glob, 'Show Row Lines', [], false),
            section: sectionMainId,
            group: 'calendar-lines-options'
        },
        {
            id: 'widget-calendar-show-column-lines',
            param: new BooleanField(glob, 'Show Column Lines', [], false),
            section: sectionMainId,
            group: 'calendar-lines-options'
        },

        {
            id: 'widget-calendar-lines-color',
            param: new ColorBoxField(glob, 'Vertical & Horizontal Lines Color', [], '#DDDDDD', {
                hideTransparency: true
            }),
            section: sectionMainId,
            group: 'calendar-lines-options'
        },

        // Panel "Other Options" ========== NO

        //The whole background color:
        {
            id: 'widget-calendar-bg-color',
            param: new ColorBoxField(
                glob,
                'Background Color',
                [],
                function (theme) {
                    return theme['surface-bg'] || '#FFFFFF';
                },
                {
                    hideTransparency: false
                }
            ),
            section: sectionMainId,
            deps: ['surface-bg'],
            group: 'calendar-group-options'
        },

        //LL: 02.08.23: new Calendar
        //LL: in Config:
        //export const Colors = {
        //    Almindelig_sygdom_BorderColor: '#bd0120',  // - red   'x'
        //    Arbejdsskade_BorderColor: '#f9e1a3',  // - бежевый
        //    p56_sygdom_BorderColor: '#623a7b',  // - violet
        //    Fri_ferie_BackColor: '#e7e7e7',  // - light gray  'g'   or ededed
        //    Ressourceforlob_BorderColor: '#e97b31',  // - orange
        //    Delvis_sygdom_BorderColor: '#426ead',  // - blue  'b'
        //    Barns_sygdom_BorderColor: '#c0c2df',  // - light gray-violet
        //    Langtidssyg_sygdom_BorderColor: '#ff8080', // mild red // 'Sygdom - langtidssyg':  //LL: длительная болезнь
        //    EmptyDay_BackColor: '#888888'  // - dark gray  'n'  or bdbdbd
        //};

        //LL: 26.06.24
        {
            id: 'widget-calendar-native',
            param: new BooleanField(
                glob,
                'Native Calendar (Sick Leaves for Danish Hospitals). Uncheck to use extended customization.',
                [],
                true
            ),
            section: sectionPeriodVisualizationId
        },

        //LL: 17.08.23: wants different for weekends (Fri_ferie_BackColor) and holidays
        //LL: now for Weekends
        {
            id: 'widget-calendar-HolidaysWeekends-bg-color',
            param: new ColorBoxField(
                glob,
                'Weekends Background Color', // 'Holidays and Weekends Background Color',
                [],
                Config.Colors.Fri_ferie_BackColor, //'#e7e7e7', // Fri_ferie_BackColor = '#e7e7e7';  // - light gray
                {
                    hideTransparency: true
                }
            ),
            section: sectionPeriodVisualizationId,
            group: groupPeriodVisualization_emptyDays_Id
        },
        //LL: 17.08.23: for Holidays
        {
            id: 'widget-calendar-Holidays-bg-color',
            param: new ColorBoxField(glob, 'Holidays Background Color', [], Config.Colors.Holidays_BackColor, {
                hideTransparency: true
            }),
            section: sectionPeriodVisualizationId,
            group: groupPeriodVisualization_emptyDays_Id
        },
        {
            id: 'widget-calendar-emptyDays-bg-color',
            param: new ColorBoxField(
                glob,
                'Empty Days Background Color',
                [],
                Config.Colors.EmptyDay_BackColor, //'#888888', // EmptyDay_BackColor = '#888888';  // - dark gray  'n'  or bdbdbd
                {
                    hideTransparency: true
                }
            ),
            section: sectionPeriodVisualizationId,
            group: groupPeriodVisualization_emptyDays_Id
        },

        //LL: 01.07.24
        {
            id: 'widget-calendar-show-legend',
            param: new BooleanField(glob, 'Show legend', [], true),
            section: sectionPeriodVisualizationId,
            group: groupPeriodVisualization_legend_Id
        },
        //LL: 13.09.23
        {
            id: 'widget-calendar-weekend-title',
            param: new StringField(
                glob,
                'Weekends Title in Legend',
                [ValidatorPlatform.string.notAllBlanks],
                'Weekends',
                { allowNull: false }
            ),
            section: sectionPeriodVisualizationId,
            group: groupPeriodVisualization_legend_Id //groupPeriodVisualization_emptyDays_Id //LL: 27.06.24
        },
        {
            id: 'widget-calendar-holiday-title',
            param: new StringField(
                glob,
                'Holidays Title in Legend',
                [ValidatorPlatform.string.notAllBlanks],
                'Holidays',
                { allowNull: false }
            ),
            section: sectionPeriodVisualizationId,
            group: groupPeriodVisualization_legend_Id //groupPeriodVisualization_emptyDays_Id //LL: 27.06.24
        },
        //LL: 27.06.24
        {
            id: 'widget-calendar-legendItem-width',
            param: new NumberField(
                glob,
                'Legend Item Width (px)',
                [
                    ValidatorPlatform.number.range(50, 1000),
                    ValidatorPlatform.number.positive,
                    ValidatorPlatform.number.integer
                ],
                180,
                {
                    applyOnEnter: true
                }
            ),
            section: sectionPeriodVisualizationId,
            group: groupPeriodVisualization_legend_Id
        },

        //LL: 11.09.23  Data Calendar Markers
        {
            id: 'widget-calendar-markers-dataQuery',
            //hidden: true, //LL: 14.09.23   Not fully implemented
            hidden: Config.UseExternalDataQueryForPeriodTypes !== true, //LL: 30.09.23
            param: new AttributesParameterField(
                this.glob,
                'Data for Period Types',
                [validators.validateRolesPar(Config.DisplayValuesList_PeriodTypes, 'Period Types')],
                null,
                {
                    showApplyButton: true, //LL: 12.09.23
                    //DisplayValuesList: CalendarWidget.DisplayValuesList_PeriodTypes,
                    DisplayValuesList: Config.DisplayValuesList_PeriodTypes,
                    //hiddenFields: CalendarWidget.HiddenFields_PeriodTypes,
                    hiddenFields: Config.HiddenFields_PeriodTypes,
                    theme: {} //theme,
                    //tabID: tabID
                }
            ),
            section: sectionPeriodVisualizationId,
            group: 'calendar-visualization-markers-dataQuery'
        },

        //LL: 07.08.23  Calendar Markers
        {
            id: 'widget-calendar-markers',
            param: new CalendarMarkersField(
                this.glob,
                'Mapping Period Types to Styles', //'Styles', //'Markers',
                [
                    validators.styles_namesUnique //LL: 05.09.23
                    //ChartValidators.chartParams.customStyles_shouldHaveNames,
                    //ChartValidators.chartParams.customStyles_namesUnique,
                    //ChartValidators.chartParams.customStyles_Opacity
                ],
                null,
                {
                    builtinMarkers: [
                        {
                            name: 'Sygd 1',
                            code: 's1',
                            label: 'sygdom AAA',
                            useBorderColor: true,
                            borderColor: 'green',
                            symbol: 'y',
                            useSymbolColor: false,
                            symbolColor: 'blue',
                            pattern: 'diagonalLeft',
                            patternBackColor: 'transparent',
                            patternColor: 'coral'
                        }
                    ]
                }
            ),
            isArray: true, //LL: but maybe not needed
            prohibitClearable: true, //LL: 24.04.20
            prohibitInheritedIcon: true, //LL: 24.04.20
            merger: appTheme.mergerForArrays,
            section: sectionPeriodVisualizationId,
            group: 'calendar-visualization-markers'
        }

        //LL: 17.08.23: commented, don't rem
        //LL: sample:
        // almindelig sygdom - распространенное заболевание
        //{
        //    id: 'calendar-visualization-almindelig-sygdom',
        //    name: 'almindelig sygdom',
        //    section: sectionPeriodVisualizationId
        //}
        //{
        //    id: 'widget-calendar-almindelig-sygdom-border-color',
        //    param: new ColorBoxField(
        //        glob,
        //        'Border Color',
        //        [],
        //        '#bd0120', // ~~red  krapp(marena)
        //        //null,
        //        {
        //            hideTransparency: true
        //        }
        //    ),
        //    section: sectionPeriodVisualizationId,
        //    group: 'calendar-visualization-almindelig-sygdom'
        //},

        //LL: 20.10.20: Column Chooser
        //{
        //    id: 'widget-grid-column-chooser-show',
        //    param: new BooleanField(glob, 'Show Column Chooser Button in Grid Toolbar', [], false),
        //    section: sectionMainId,
        //    group: 'grid-group-column-chooser'
        //},
        //{
        //    id: 'widget-grid-reset-layout-button-show',
        //    param: new BooleanField(glob, 'Show Reset Layout Button in Grid Toolbar', [], false),
        //    section: sectionMainId,
        //    group: 'grid-group-column-chooser'
        //},
        //{
        //    id: 'widget-grid-column-chooser-mode',
        //    hidden: true,
        //    param: new SelectField(glob, 'Column Chooser Mode', [], 'dragAndDrop', {
        //        values: ['dragAndDrop', 'select'],
        //        display: ['Drag and Drop', 'Select']
        //    }),
        //    section: sectionMainId,
        //    group: 'grid-group-column-chooser'
        //},
        //{
        //    id: 'widget-grid-column-chooser-width',
        //    hidden: true,
        //    param: new NumberField(
        //        glob,
        //        'Column Chooser Panel Width (150-800)',
        //        [
        //            ValidatorPlatform.number.range(150, 800),
        //            ValidatorPlatform.number.positive,
        //            ValidatorPlatform.number.integer
        //        ],
        //        250, //LL:  DevExpr default
        //        {
        //            //min: 150,
        //            //max: 800,
        //            applyOnEnter: true
        //        }
        //    ),
        //    section: sectionMainId,
        //    group: 'grid-group-column-chooser'
        //},
        //{
        //    id: 'widget-grid-column-picker-width',
        //    hidden: true,
        //    param: new NumberField(
        //        glob,
        //        'Column Chooser Dialog Width (150-800)',
        //        [
        //            ValidatorPlatform.number.range(150, 800),
        //            ValidatorPlatform.number.positive,
        //            ValidatorPlatform.number.integer
        //        ],
        //        300,
        //        {
        //            //min: 150,
        //            //max: 800,
        //            applyOnEnter: true
        //        }
        //    ),
        //    section: sectionMainId,
        //    group: 'grid-group-column-chooser'
        //},
        //{
        //    id: 'widget-grid-column-chooser-height',
        //    hidden: true,
        //    param: new NumberField(
        //        glob,
        //        'Column Chooser Panel Height (130-800)',
        //        [
        //            ValidatorPlatform.number.range(130, 800),
        //            ValidatorPlatform.number.positive,
        //            ValidatorPlatform.number.integer
        //        ],
        //        260, //LL:  DevExpr default
        //        {
        //            //min: 130,
        //            //max: 800,
        //            applyOnEnter: true
        //        }
        //    ),
        //    section: sectionMainId,
        //    group: 'grid-group-column-chooser'
        //},

        //LL: 01.08.23 Calendar:  rem:   Leo does not want
        //{
        //    id: 'widget-calendar-show-search',
        //    param: new BooleanField(glob, 'Show Search Panel', [], false),
        //    section: sectionMainId,
        //    group: 'calendar-group-search'
        //},
        //{
        //    id: 'widget-calendar-search-panel-width',
        //    param: new NumberField(
        //        glob,
        //        'Search Panel Width',
        //        [ValidatorPlatform.number.range(50, 300), ValidatorPlatform.number.integer],
        //        120,
        //        {
        //            applyOnEnter: true
        //        }
        //    ),
        //    section: sectionMainId,
        //    group: 'calendar-group-search'
        //},

        //LL: 10.07.23 Calendar:  rem:
        //{
        //    id: 'widget-grid-dataRetrieving-specialMainGroupHandling',
        //    param: new BooleanField(glob, 'Special Main Group Handling', [], false),
        //    section: sectionMainId,
        //    group: 'grid-group-dataRetrieving'
        //},

        //LL: 10.07.23 Calendar:  rem:
        //{
        //    id: 'widget-grid-native-scrollbar',
        //    param: new BooleanField(glob, 'Native scrollbar', [], true),
        //    section: sectionMainId,
        //    group: 'grid-group-native-scrollbar'
        //}
    ]);

    //LL: 10.07.23 Calendar: rem  NO
    // Register templates
    appTheme.registerTemplate(template, ['pdc-widget-calendar']);

    appTheme.registerPreRender(function (input) {
        var vars = {};

        //color.luminosity();  //ex: 0.412 (0 is black, 1 is white.)
        // The [WCAG luminosity](http://www.w3.org/TR/WCAG20/#relativeluminancedef) of the color. 0 is black, 1 is white.

        //var colorArr = Color(input['widget-grid-rowbg-color']).rgbArray();
        //vars['widget-grid-rowbg-color-r'] = colorArr[0];
        //vars['widget-grid-rowbg-color-g'] = colorArr[1];
        //vars['widget-grid-rowbg-color-b'] = colorArr[2];
        //vars['widget-grid-rowbg-color-op'] = 1.0-(Color(input['widget-grid-rowbg-color']).luminosity()*0.8);
        //
        //var colorAltArr = Color(input['widget-grid-rowbgalt-color']).rgbArray();
        //vars['widget-grid-rowbgalt-color-r'] = colorAltArr[0];
        //vars['widget-grid-rowbgalt-color-g'] = colorAltArr[1];
        //vars['widget-grid-rowbgalt-color-b'] = colorAltArr[2];
        //vars['widget-grid-rowbgalt-color-op'] = 1.0-(Color(input['widget-grid-rowbgalt-color']).luminosity()*0.8);

        return _.extend(input, vars);
    });
    _init.push(glob);
}

